import { useSession } from "@/lib/auth/auth";

import type { BackgroundJob } from "@/apis/gql/types";
import { useBrowserSessionId } from "@/hooks/useBrowserSessionId";
import { useTenant } from "@/providers/session";
import { gql, useSubscription } from "@apollo/client";

export const useJobStatusSubscription = () => {
  const { tenantId } = useTenant();
  const { data: session } = useSession();

  const sessionId = useBrowserSessionId();

  const userId = session?.user?.id;

  const { data, loading } = useSubscription<{ jobStatus: BackgroundJob }>(
    JOB_STATUS_SUBSCRIPTION,
    {
      variables: { tenantId, userId, sessionId },
      skip: !tenantId || !userId || !sessionId,
    },
  );

  return { data, loading };
};

export const JOB_STATUS_SUBSCRIPTION = gql`
  subscription JobStatus(
    $tenantId: String!
    $userId: String!
    $sessionId: String!
  ) {
    jobStatus(tenantId: $tenantId, userId: $userId, sessionId: $sessionId) {
      jobId
      jobName
      status
      progress
      timestamp
      meta
      returnvalue
      data
    }
  }
`;
